import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import {
  Overlay,
  DialogContainer
} from './components/Styled';

import DialogCard from './components/DialogCard';

const Root = document.getElementById('root-contain');

export class Dialog extends Component {
  constructor (props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.showDialog = this.showDialog.bind(this);

    this.state = {
      open: false || props.open
    };
  }

  showDialog (open) {
    this.setState(() => ({ open }));
  }

  onCancel () {
    let { onClose } = this.props;

    this.showDialog(false);
    onClose && onClose();
  }

  componentWillReceiveProps ({ open }) {
    let { open: isOpen } = this.state;
    if (open !== isOpen) this.showDialog(open);
  }

  onSubmit () {
    let { onSubmit } = this.props;
    onSubmit && onSubmit();
  }

  render () {
    let {
      title,
      loading,
      subTitle,
      children,
      hideCancel,
      hideSubmit,
      submitLabel,
      allowSubmit,
      cancelLabel,
      hideActions,
      showFloatingCancel
    } = this.props;

    let { open } = this.state;

    if (!open) return null;

    return ReactDOM.createPortal(
      <React.Fragment>
        <DialogContainer>
          <DialogCard
            Title={title}
            loading={loading}
            SubTitle={subTitle}
            hideCancel={hideCancel}
            hideSubmit={hideSubmit}
            cancelLabel={cancelLabel}
            submitLabel={submitLabel}
            allowSubmit={allowSubmit}
            onSubmit={this.onSubmit}
            onCancel={this.onCancel}
            hideActions={hideActions}
            showFloatingCancel={showFloatingCancel}
          >
            {children}
          </DialogCard>
        </DialogContainer>
        <Overlay />
      </React.Fragment>
    , Root);
  }
}

export default Dialog;
